/* NEX: adds the small add-to-bag icon to every product shown on the Winter / Summer / Hats pages */
(function () {
  function handleOf(a) { var m = (a.getAttribute('href') || '').match(/\/products\/([^/?#]+)/); return m ? m[1] : ''; }
  function build(a, host, inOrbit) {
    if (!a || a.querySelector('.sx__add')) return;
    var h = handleOf(a); if (!h) return;
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'sx__add'; b.setAttribute('data-qa', h); b.setAttribute('aria-label', 'Add to bag');
    if (/[?&]variant=/.test(a.getAttribute('href') || '')) {
      var n = a.querySelector('.sx__pn,.sx__on'); if (n) b.setAttribute('data-color', n.textContent.trim());
    }
    if (a.querySelector('.sx__so')) b.disabled = true;
    b.addEventListener('pointerdown', function (e) { e.stopPropagation(); });
    b.addEventListener('mousedown', function (e) { e.stopPropagation(); });
    host.appendChild(b);
  }
  function run() {
    document.querySelectorAll('.sx .sx__p').forEach(function (a) { build(a, a.querySelector('.sx__pm') || a); });
    document.querySelectorAll('.sx .sx__of a').forEach(function (a) { build(a, a); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
